import api from "../../api/api";
import { V2_BASE_URL } from "../../api/bases";
import { getPracticeId } from "../../config/practice";

/* Timesheet recap for every report (the Reports table, the employee / day modals and both PDFs).
   Pinned to v2 (review 10-19), like the corrections calls: only v2's recap carries approved_hours (owner
   10-19: reports count approved hours only). Through the v1/v2 routing a v1 fallback answered without it,
   and the same report then counted differently. If v2 does not answer, the report shows no data instead of
   unapproved hours. */
const V2 = { baseURL: V2_BASE_URL, _gw: "v2-pinned" };

export const fetchRecap = (params) =>
  api.get(`/v1/${getPracticeId()}/timesheet/recap`, { ...V2, params });
